import { render } from "./ExitConfirmForm.vue?vue&type=template&id=65addbd2"
import script from "./ExitConfirmForm.vue?vue&type=script&lang=js"
export * from "./ExitConfirmForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__